export default __webpack_public_path__ + "static/tumeric-ebfa9ca9ea7811a1f466d315945068c8.png";